import { handleResponse } from "utils/utils";
import { authService } from "services";

export const payflowIntegrationService = {
	getIntegrations,
	updateIntegrations,
	getSyncLogs,
};

function authHeaders() {
	return {
		Authorization: `Bearer ${authService.token.access_token}`,
		"Content-Type": "application/json",
	};
}

function getIntegrations() {
	return fetch(`${global.BASE_API}companies/integrations`, {
		method: "GET",
		headers: authHeaders(),
	}).then(handleResponse);
}

function updateIntegrations(data) {
	return fetch(`${global.BASE_API}companies/integrations`, {
		method: "PUT",
		headers: authHeaders(),
		body: JSON.stringify(data),
	}).then(handleResponse);
}

function getSyncLogs(options = {}) {
	const params = new URLSearchParams();
	if (options.employee_id != null) {
		params.set("employee_id", options.employee_id);
	}

	const query = params.toString();
	const url = `${global.BASE_API}payflow-integration${query ? `?${query}` : ""}`;

	return fetch(url, {
		method: "GET",
		headers: authHeaders(),
	}).then(handleResponse);
}
